import { useState, useEffect } from "react";
import { Row, Col, Drawer, Typography } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import { useLocation } from "react-router-dom";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  BackgroundImage,
  NotHidden,
  Menu,
  NavContainer,
  CustomNavLinkSmall,
  CustomNavLinkExternal,
  Label,
  Outline,
  Span,
  Dropdown,
  DropdownItem,
  TopMenu,
  CenteredSection,
  FloatingArrow,
  TextBubble,
} from "./styles";

const Header = ({ t }: any) => {
  const [visible, setVisibility] = useState(false);
  const [currentPage, setCurrentPage] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 890);
  const isDefaultPage = currentPage === "default";
  const location = useLocation();

  useEffect(() => {
    const subpath = location.pathname.split("/")[1];
    if (subpath) {
      setCurrentPage(subpath);
    } else {
      setCurrentPage("default");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 890);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(false);
  };

  const MenuItem = () => {
    return (
      <NavContainer>
        {isMobile && <CustomNavLinkSmall onClick={onClose} to="/">
          <Span>{t("Home")}</Span>
        </CustomNavLinkSmall>}
        <CustomNavLinkSmall onClick={onClose} to="/psychology">
          <Span>{t("Psychology")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={onClose} to="/equine">
          <Span>{t("Equine Therapy")}</Span>
        </CustomNavLinkSmall>
        <Dropdown>
          <CustomNavLinkSmall onClick={onClose} to="/resources">
              {t("Resources")}
            </CustomNavLinkSmall>
          <DropdownItem>
            <CustomNavLinkSmall onClick={onClose} to="/referral">
            <Span>{t("Referral")}</Span>
          </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={onClose} to="/contact">
              {t("Contact")}
            </CustomNavLinkSmall>
          </DropdownItem>
        </Dropdown>
        <CustomNavLinkExternal
          style={{ width: "160px" }}
          href="https://clientportal.powerdiary.com/clientportal/boology"
          target="_blank"
        >
          <Button>{t("Book a session")}</Button>
        </CustomNavLinkExternal>
      </NavContainer>
    );
  };
  const { Title, Paragraph } = Typography;
  const determineHeaderContent = () => {
    if (currentPage === "default") {
      return (
        <>
          <Title
            level={1}
            style={{
              color: "#fff",
              fontWeight: 500,
              textShadow: "0 3px 10px rgba(0,0,0,0.6)"
            }}
          >
            Welcome
          </Title>

          <TextBubble>
            <Paragraph
              style={{
                paddingTop: "2rem",
                color: "#353535ff",
                fontSize: "1.2rem",
                fontWeight: 400,
                margin: 0,
                textShadow: "none"
              }}
            >
              Boonooloo Psychology is a locally owned and managed mental health
              clinic in Speewah. We are passionate about delivering mental health
              services to people in Cairns & the Tablelands.
            </Paragraph>
          </TextBubble>
        </>
      );
    }

    if (currentPage === "equine") {
      return (
        <>
          <Title
            level={1}
            style={{
              color: "#fff",
              fontWeight: 500,
              textShadow: "0 3px 10px rgba(0,0,0,0.6)"
            }}
          >
            Equine Therapy
          </Title>
        </>
      );
    }

    const capitalized = currentPage.charAt(0).toUpperCase() + currentPage.slice(1);

    return (
      <>
        <Title
          level={1}
          style={{
            color: "#fff",
            fontWeight: 500,
            textShadow: "0 3px 10px rgba(0,0,0,0.6)"
          }}
        >
          {capitalized}
        </Title>
      </>
    );
  };

  return (
    <HeaderSection isDefaultPage={isDefaultPage}>
      <BackgroundImage isDefaultPage={isDefaultPage} isMobile={isMobile}>
        <Container>
          <TopMenu>
            <Row justify="space-between">
              <LogoContainer to="/" aria-label="homepage">
                <SvgIcon
                  src="../logo_transparent.png"
                  width="170px"
                  height="61px"
                />
              </LogoContainer>
              <NotHidden>
                <MenuItem />
              </NotHidden>
              <Burger onClick={showDrawer}>
                <Outline />
              </Burger>
            </Row>
            <Drawer closable={false} visible={visible} onClose={onClose}>
              <Col style={{ marginBottom: "2.5rem" }}>
                <Label onClick={onClose}>
                  <Col span={12}>
                    <Menu>Menu</Menu>
                  </Col>
                  <Col span={12}>
                    <Outline />
                  </Col>
                </Label>
              </Col>
              <MenuItem />
            </Drawer>
          </TopMenu>
          <CenteredSection>
            {determineHeaderContent()}
            {isDefaultPage && <FloatingArrow />}
          </CenteredSection>
        </Container>
      </BackgroundImage>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
